const STORAGE_KEY_PREFIX = 'first-analysis-batch'

type FirstBatchData = {
  initialBatchSize: number
  totalTriggered: number
  triggeredAll: boolean
  triggeredFindingIds: string[]
}

function getStorageKey(scanId: string): string {
  return `${STORAGE_KEY_PREFIX}-${scanId}`
}

export function getFirstBatchData(scanId: string): FirstBatchData | null {
  try {
    const data = localStorage.getItem(getStorageKey(scanId))
    if (!data) return null
    return JSON.parse(data) as FirstBatchData
  } catch {
    return null
  }
}

export function initializeFirstBatch(scanId: string, batchSize: number, findingIds?: string[]): void {
  const existing = getFirstBatchData(scanId)
  if (existing) {
    if (existing.triggeredAll) {
      return
    }
    if (!findingIds) {
      return
    }
    const existingIds = new Set(existing.triggeredFindingIds)
    const newIds = findingIds.filter(id => !existingIds.has(id))
    const updated: FirstBatchData = {
      initialBatchSize: existing.initialBatchSize,
      totalTriggered: existing.totalTriggered + newIds.length,
      triggeredAll: false,
      triggeredFindingIds: [...existing.triggeredFindingIds, ...newIds],
    }
    localStorage.setItem(getStorageKey(scanId), JSON.stringify(updated))
  } else {
    const data: FirstBatchData = {
      initialBatchSize: batchSize,
      totalTriggered: batchSize,
      triggeredAll: !findingIds,
      triggeredFindingIds: findingIds ?? [],
    }
    localStorage.setItem(getStorageKey(scanId), JSON.stringify(data))
  }
}

export function isFirstBatchComplete({
  scanId,
  completedAnalysis,
  totalFindings,
}: {
  scanId: string
  completedAnalysis: number
  totalFindings?: number
}): boolean {
  const data = getFirstBatchData(scanId)
  if (!data) return true

  const target = data.triggeredAll && totalFindings !== undefined ? totalFindings : data.totalTriggered
  return completedAnalysis >= target
}

export function clearFirstBatchData(scanId: string): void {
  localStorage.removeItem(getStorageKey(scanId))
}
